import React, { useState } from "react";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import CarpetaMedica from "../NCadetes/CarpetaMedica";
import { useNavigate } from "react-router-dom";
import comprueboPermisos from "../tools/comprueboPermisos";
import ListadoInscripciones from "../Inscripciones/ListadoInscripciones";
import ProcesosSanidadViewer from "./ProcesosSanidadViewer";
import ModuloSanidadAusenciasDocentes from "./ModuloSanidadAusenciasDocentes";

const Sanidad = () => {
  const navitate = useNavigate();
  const Usuario = ObtieneDatosCookies();
  const [vista, setVista] = useState("carpeta");

  return (
    <div style={styles.container}>

      {/* HEADER */}
      <div style={styles.header}>
        <h1 style={styles.title}>División Sanidad</h1>

        <button
          onClick={() => navitate("/usuarioLogueado")}
          className="btn btn-warning"
        >
          ← Volver
        </button>
      </div>

      {/* BOTONES */}
      <div style={styles.buttonGroup}>
        <button
          onClick={() => setVista("carpeta")}
          className={`btn ${vista === "carpeta" ? "btn-dark" : "btn-outline-primary"
            }`}
        >
          Carpeta Médica Cadetes
        </button>
        <button
          onClick={() => setVista("carpetaDocente")}
          className={`btn ${vista === "carpetaDocente" ? "btn-dark" : "btn-outline-primary"
            }`}
        >
          Carpeta Médica Docentes
        </button>
        {comprueboPermisos(Usuario.funcion, "Veo Procesos Sanidad") ? (
          <button
            onClick={() => setVista("procesos")}
            className={`btn ${vista === "procesos" ? "btn-dark" : "btn-outline-success"
              }`}
          >
            Procesos de Ingreso
          </button>
        ) : (
          ""
        )}
      </div>

      {/* CONTENIDO */}
      <div style={styles.content}>
        {vista == "carpeta" && <CarpetaMedica />}
        {vista == "carpetaDocente" && <ModuloSanidadAusenciasDocentes />}
        {vista === "procesos" && <ProcesosSanidadViewer />}
      </div>
    </div>
  );
};

export default Sanidad;

const styles = {
  container: {
    width: "95vw",
    maxWidth: "95vw",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "sans-serif",
  },

  content: {
    background: "#fff",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    minHeight: "300px",
    width: "100%",
    maxWidth: "100%",
    overflowX: "auto",
  },

  header: {
    textAlign: "center",
    marginBottom: "20px",
  },

  title: {
    marginBottom: "10px",
    color: "#333",
  },

  buttonGroup: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    flexWrap: "wrap",
    marginBottom: "20px",
  },


};